<template>
    <v-container class="main-container responsive-height mt5-details-wrapper">
        <v-row dense>
            <v-col cols="12" md="7">
                <TitleCard></TitleCard>
                <v-row dense>
                    <v-col
                        cols="12"
                        sm="4"
                        v-for="item in forecast"
                        :key="item.day"
                    >
                        <v-card
                            outlined
                            tile
                            :to="item.links"
                            :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'"
                            class="widgets-card"
                        >
                            <v-btn
                                class="mx-2 mb-3"
                                fab
                                link
                                small
                                elevation="0"
                                :color="
                                    $vuetify.theme.dark ? '#1A2A3E ' : '#F8F6FC'
                                "
                            >
                                <v-icon color="greenMain">
                                    {{ item.icon }}
                                </v-icon>
                            </v-btn>
                            <p class="mb-0">{{ item.day }}</p>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" md="5">
                <BalanceCard></BalanceCard>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <MiddleBar></MiddleBar>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12" md="12" class="position-relative">
                <Mt5DetailsAllTabs></Mt5DetailsAllTabs>
                <v-card class="profit-loss rounded-0" flat color="transparent">
                    <ul>
                        <li>
                            <span class="text-warning">Total Lot:</span>
                            <span>{{
                                accountSpecificLiveTradesSummary.totalLot.toFixed(
                                    2
                                )
                            }}</span>
                        </li>
                        <li>
                            <span class="profit-losses">Profit / Loss:</span>
                            <span>{{
                                accountSpecificLiveTradesSummary.profitLoss.toFixed(
                                    2
                                )
                            }}</span>
                        </li>
                    </ul>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { TRADING__ACTIONS } from "@/store/action-types";

import BalanceCard from "@/components/PagesComponents/Mt5DetailsPage/BalanceCard.vue";
import MiddleBar from "@/components/PagesComponents/Mt5DetailsPage/MiddleBar.vue";
import Mt5DetailsAllTabs from "@/components/PagesComponents/Mt5DetailsPage/Mt5DetailsAllTabs.vue";
import TitleCard from "@/components/PagesComponents/Mt5DetailsPage/TitleCard.vue";
export default {
    data: () => ({
        forecast: [
            { day: "Deposit", icon: "mdi-tray-arrow-down", links: "/deposit" },
            {
                day: "Transfer",
                icon: "mdi-swap-horizontal",
                links: "/internal-transfer",
            },
            {
                day: "Change Password",
                icon: "mdi-lock-open-outline",
                links: "/change-mt5-password",
            },
        ],
    }),
    components: {
        BalanceCard,
        TitleCard,
        MiddleBar,
        Mt5DetailsAllTabs,
    },
    computed: {
        ...mapState("trading", [
            "mt5AccountDetails",
            "accountSpecificLiveTradesSummary",
        ]),
    },
    methods: {
        ...mapActions("trading", [
            TRADING__ACTIONS.MT5ACCOUNTDETAILS,
            TRADING__ACTIONS.CLIENTLIVETRADES,
        ]),
    },
    async mounted() {
        await this[TRADING__ACTIONS.MT5ACCOUNTDETAILS](this.$route.query.id);
        await this[TRADING__ACTIONS.CLIENTLIVETRADES](this.$route.query.id);
    },
};
</script>
